var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BiLayoutBox',{attrs:{"nav-list":_vm.navList2},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('SideBar',{attrs:{"nav-config":_vm.sideBarList}})]},proxy:true},{key:"right",fn:function(){return [_c('router-view',{key:"key"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }